module.exports = __webpack_public_path__ + "static/media/Appentura_white.ab4ef80b.svg";